import { create } from "zustand";
import { getComparator, stableSort } from "../../../ListadoFunciones";

export const createRowStore = (opciones = {}) =>
  create((set, get) => ({
    // Estado de las filas indexado por el identificador (_key)
    rowStates: {},

    // Función para inicializar el estado de una fila (si aún no existe)
    initRowState: (key, initialData) =>
      set((state) => ({
        rowStates: {
          ...state.rowStates,
          [key]: state.rowStates[key] || initialData,
        },
      })),
    initState: (datos) => {
      const newRowStates = {};
      datos.forEach((initialData) => {
        newRowStates[initialData._key] = initialData;
      });
      set((state) => ({
        rowStates: newRowStates,
      }));

      let allGlobalChecked = false;
      let someGlobalChecked = false;

      if (opciones.showSelectAllCheckbox === "s") {
        allGlobalChecked =
          Object.values(newRowStates).length > 0 &&
          Object.values(newRowStates).every((row) => row?._checked);

        someGlobalChecked = Object.values(newRowStates).some(
          (row) => row?._checked
        );
      }
      if (opciones.paginar_backend !== "s") {
        set(() => ({
          count: datos.length,
        }));
      }
      set(() => ({
        datos,
        globalChecked: allGlobalChecked,
        globalIndeterminateChecked: !allGlobalChecked && someGlobalChecked,
      }));
    },
    // Función para actualizar el estado de una fila
    updateRowState: (key, newData) => {
      set((state) => ({
        rowStates: {
          ...state.rowStates,
          [key]: { ...state.rowStates[key], ...newData },
        },
      }));

      return get().rowStates[key];
    },

    // Función para alternar el estado de "_checked"
    checkRow: (key) => {
      set((state) => {
        const updatedRow = {
          ...state.rowStates[key],
          _checked: !state.rowStates[key]?._checked,
        };

        let allGlobalChecked = false;
        let someGlobalChecked = false;

        if (opciones.showSelectAllCheckbox === "s") {
          const newRowStates = { ...state.rowStates, [key]: updatedRow };

          allGlobalChecked =
            Object.values(newRowStates).length > 0 &&
            Object.values(newRowStates).every((row) => row?._checked);

          someGlobalChecked = Object.values(newRowStates).some(
            (row) => row?._checked
          );
        }

        return {
          rowStates: {
            ...state.rowStates,
            [key]: updatedRow,
          },
          globalChecked: allGlobalChecked,
          globalIndeterminateChecked: !allGlobalChecked && someGlobalChecked,
        };
      });
      return get().rowStates[key];
    },
    checkAllVisibleRows: () => {
      set((state) => {
        // Obtiene las filas visibles a partir del método getVisibleRows del store
        const visibleRows = get().getVisibleRows();
        // Copia del estado actual de rowStates
        const newRowStates = { ...state.rowStates };

        // Determinar si todas las filas visibles están marcadas
        const allVisibleChecked = visibleRows.every(
          (row) => newRowStates[row._key]?._checked
        );
        // Si todas las visibles están marcadas, se desmarcan; de lo contrario, se marcan todas.
        const newCheckedState = !allVisibleChecked;

        // Actualizamos solo las filas visibles
        visibleRows.forEach((row) => {
          newRowStates[row._key] = {
            ...newRowStates[row._key],
            _checked: newCheckedState,
          };
        });

        // Calculamos el estado global: para ello evaluamos todas las filas del store.
        const allGlobalChecked =
          Object.values(newRowStates).length > 0 &&
          Object.values(newRowStates).every((row) => row?._checked);
        const someGlobalChecked = Object.values(newRowStates).some(
          (row) => row?._checked
        );

        return {
          ...state,
          rowStates: newRowStates,
          globalChecked: allGlobalChecked, // globalChecked es true solo si TODAS están marcadas
          globalIndeterminateChecked: !allGlobalChecked && someGlobalChecked, // indeterminado si algunas (pero no todas) están marcadas
        };
      });

      return get().getVisibleRows();
    },

    page: 0,
    rowsPerPage: opciones.cantdd_registros
      ? Number(opciones.cantdd_registros)
      : 10,
    order: "asc",
    orderBy: "id",
    count: 0,
    datos: [],

    setPage: (newPage) => set({ page: newPage }),
    setRowsPerPage: (newRowsPerPage) => set({ rowsPerPage: newRowsPerPage }),
    setOrder: (newOrder) => set({ order: newOrder }),
    setOrderBy: (newOrderBy) => set({ orderBy: newOrderBy }),
    setCount: (count) => set({ count }),

    getSortedRows: () => {
      const { rowStates, order, orderBy } = get();
      const rowsArray = Object.values(rowStates);

      return stableSort(rowsArray, getComparator(order, orderBy));
    },

    getVisibleRows: () => {
      const sortedRows = get().getSortedRows();
      if (opciones.paginar_backend === "s") return sortedRows;
      const { page, rowsPerPage } = get();
      return sortedRows.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      );
    },
  }));
